import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { INPUT_VALUE_COVER_TYPE_SOFT } from '@shared/common/product';
import type { TBookAlias } from '@shared/jp/product';
import { TBookCover } from '@shared/jp/product';
import type { IBookPreview } from '@shared/jp/data/products';
import { IShipping } from '@shared/jp/data/shipping';
import { slideY } from '@studiobuki/web-core';
import { BehaviorSubject } from 'rxjs';
import { getGiftCaption } from 'src/app/data/books/gift-caption';

@Component({
  selector: 'app-section-gift-books',
  templateUrl: './section-gift-books.component.html',
  styleUrls: ['./section-gift-books.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideY()],
})
export class SectionGiftBooksComponent {
  @Input() books!: IBookPreview[];

  @Input() set alias(value: TBookAlias | undefined) {
    if (this._alias$.value !== value) {
      this._alias$.next(value);
      this.aliasChange.emit(value);
    }
  }

  @Output() aliasChange = new EventEmitter<TBookAlias | undefined>();

  @Input() set cover(value: TBookCover) {
    if (this._cover$.value !== value) {
      this._cover$.next(value);
      this.coverChange.emit(value);
    }
  }

  @Output() coverChange = new EventEmitter();

  @Input() shipping!: IShipping;

  private _alias$ = new BehaviorSubject<TBookAlias | undefined>(undefined);

  public alias$ = this._alias$.asObservable();

  private _cover$ = new BehaviorSubject<TBookCover>(
    INPUT_VALUE_COVER_TYPE_SOFT,
  );

  public cover$ = this._cover$.asObservable();

  // constructor() {}

  public onBookClick(alias: TBookAlias): void {
    this.alias = alias;
  }

  public onChangeClick(): void {
    this.alias = undefined;
  }

  public readonly getCaption = getGiftCaption;
}
